import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-[#0a0a0a] py-20 border-t border-white/5 relative" data-id="element-128">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-[#111] border border-white/10 rounded-2xl p-8 md:p-12 shadow-lg" data-id="element-130">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 text-center" data-id="element-131">
            El verdadero riesgo no es no ganar dinero.{' '}
            <br className="hidden md:block" data-id="element-132" />
            <span className="text-[#d4a437]" data-id="element-133">Es exponerte para ganarlo.</span>
          </h2>

          <div className="space-y-6 text-neutral-300 text-lg leading-relaxed" data-id="element-134">
            <p data-id="element-135">
              El modelo de trabajo tradicional en Estados Unidos te obliga a la
              exposición. Te obliga a estar en la calle, en obras, en oficinas o
              en servicios donde eres visible. Y en el clima actual, la
              visibilidad es Peligro.
            </p>
            <p data-id="element-136">
              Muchos emprendimientos digitales te dicen que "vendas tu imagen" o
              que hagas videos mostrando tu cara para generar confianza. Pero tú
              no buscas fama; buscas seguridad. No quieres que tu rostro circule
              en redes sociales; quieres que el dinero circule hacia tu cuenta
              bancaria de forma silenciosa y constante.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}